import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router';
import { ROUTES } from 'apps/sigma2-ui/src/constants/pages';
import './global.css';
import { ErrorBoundary } from 'apps/sigma2-ui/src/components/ErrorBoundary';
import { AppWrapper } from 'apps/sigma2-ui/src/components/AppWrapper';

const router = createBrowserRouter(
  ROUTES.map(({ route, appWrapperOverride }) => {
    const useEmbedWrapper = appWrapperOverride === 'embed';
    return {
      element: useEmbedWrapper ? (
        route.element
      ) : (
        <AppWrapper>{route.element}</AppWrapper>
      ),
      path: route.path,
    };
  }),
);

export const App = () => {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};
